import ImageUploader from './component/image';
import PdfUploader from './component/pdf';
import ImageCropper from './component/imgCropper';

export default {
  Image: ImageUploader,
  Pdf: PdfUploader,
  ImageCro:ImageCropper
};
